import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value", "required", "disabled", "placeholder", "maxlength"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("input", {
        ref: "inputRef",
        type: "text",
        class: "form-control",
        value: _ctx.modelValue,
        required: _ctx.required,
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        maxlength: _ctx.maxLength,
        autocapitalize: "characters",
        spellcheck: "false",
        onInput: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onPaste: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
    }, null, 40, _hoisted_1));
}
